<template>
  <div class="common-text-box-option">
    <div class="input-area">
      <date-picker
        class="mr-3"
        :applyCallBack="onSelectDate"
        :disabled="isDateSelectDisabled"
        :value.sync="date"
      ></date-picker>
      <dropdown-select
        class="filter-input mr-3"
        :selectOptions="roleOptions"
        :selectedValue.sync="selectedRole"
        placeholder="選択してください"
        :disabled="isRoleSelectDisabled"
        :border="true"
      ></dropdown-select>
      <vs-checkbox
        v-show="showApproverCheckbox"
        v-model="isApprover"
        :color="AISEA_COLOR.BLUE"
        :disabled="isApproverCheckboxDisabled"
      >
        承認権限
      </vs-checkbox>

      <div v-if="deleteButton" class="icon-button" @click="onClickDelete">
        <feather-icon
          icon="Trash2Icon"
          class="trash-icon-button"
          svg-classes="h-6 w-6"
        />
      </div>
    </div>
  </div>
</template>

<script>
import DatePicker from "../components/DatePicker.vue";
import DropdownSelect from "../components/DropdownSelect.vue";
import { ColorMixin } from "@/mixins";
export default {
  name: "M.CommonTextBoxOption",
  components: {
    DatePicker,
    DropdownSelect,
  },
  mixins: [ColorMixin],

  props: {
    roleOptions: {
      type: Array,
      required: true,
    },
    deleteButton: {
      type: Boolean,
      default: false,
    },
    onClickDelete: {
      type: Function,
      default: () => {},
    },
    isRoleSelectDisabled: {
      type: Boolean,
      default: false,
    },
    isDateSelectDisabled: {
      type: Boolean,
      default: false,
    },
    isApproverCheckboxDisabled: {
      type: Boolean,
      default: false,
    },
    value: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },

  data() {
    return {
      selectedRole: null,
      date: null,
      isApprover: false,
      showApproverCheckbox: false,
    };
  },
  watch: {
    selectedRole() {
      this.updateParentValue();
    },
    date() {
      this.updateParentValue();
    },
    isApprover() {
      this.updateParentValue();
    },
    value: {
      handler: function(val) {
        if (val != null) {
          this.selectedRole = val.role;
          this.date = val.date;
          this.isApprover = this.checkLaborAdminType(val);
        }
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    onSelectDate(value) {
      this.date = value;
    },
    updateParentValue() {
      const newValue = {
        role: this.selectedRole,
        date: this.date,
        is_labor_admin: this.isApprover,
      };
      this.$emit("update:value", newValue);
    },
    checkLaborAdminType(val) {
      if (val.role == null) return false;

      const laborAdminType = this.roleOptions.find(el => el.value === val.role)
        .laborAdminType;

      if (laborAdminType === "VAR") {
        this.showApproverCheckbox = true;
        return val.is_labor_admin;
      }

      if (laborAdminType === "OFF") {
        this.showApproverCheckbox = false;
        return false;
      }

      if (laborAdminType === "ON") {
        this.showApproverCheckbox = true;
        return true;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/aisea/_variables.scss";
@import "@/assets/scss/aisea/_typography.scss";

.common-text-box-option {
  width: 100%;
  .form-item-title {
    margin-bottom: 6px;
  }
  .input-area {
    display: flex;
    .full-width-input {
      width: 100%;
    }
  }
  .icon-button {
    cursor: pointer;
    justify-content: center;
    display: flex;
    align-items: center;
    margin-left: 10px;
    width: 36px;
    height: 36px;
  }
  .trash-icon-button {
    background: white;
    border-radius: 6px;
    width: 34px;
    height: 34px;
    //border: 1px solid $border-color1;
    display: flex;
    justify-content: center;
    color: $aisea-gray-black;
    transition: 0.3s;
    cursor: pointer;
    &:hover {
      background: $aisea-light-white;
    }
  }
}
</style>
